/**
 * Round 10: "first page view per browser session, every navbar figure does a quick recount on
 * mount... record the session in sessionStorage... so it doesn't replay on every navigation."
 * All four (React) or four (static) figures on a given page load must agree on the SAME answer
 * (either all recount together, staggered, or none do): this is called exactly ONCE per page
 * load, by the container that owns all of them (IndexStrip.tsx; the static script's own
 * equivalent in landing-nav-live-index-script.ts calls the same logic inline in plain JS, see
 * that file's own comment), never once per individual figure, or the first figure to check would
 * mark the session as "seen" before its siblings' own checks ran.
 */
const SESSION_KEY = 'jc_nav_figures_recounted';

/**
 * True exactly once per browser session (first call on the first page load after opening the
 * browser/tab), then false on every later page load in that same session. If sessionStorage is
 * unavailable (private browsing, quota, disabled storage), returns true every time (per spec:
 * "if storage is unavailable, still animate once per page load") rather than silently disabling
 * the effect for the whole session.
 */
export function shouldRecountNavFiguresThisPageLoad(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    if (!window.sessionStorage) return true;
    if (window.sessionStorage.getItem(SESSION_KEY) === '1') return false;
    window.sessionStorage.setItem(SESSION_KEY, '1');
    return true;
  } catch {
    return true;
  }
}
